import { FieldType } from '@ngx-formly/material';

import { Component } from '@angular/core';

import { ISnColorPickerFormFieldConfig } from '../../interfaces/color-picker-form-field-config.interface';
import { ISnColorPickerTemplateOptions } from '../../interfaces/color-picker-template-options.interface';

@Component({
  selector: 'sn-color-picker-form-field',
  templateUrl: './color-picker.form-field.html',
  styleUrls: ['./color-picker.form-field.scss'],
})
export class SnColorPickerFormField extends FieldType<ISnColorPickerFormFieldConfig> {
  public readonly defaultOptions: ISnColorPickerFormFieldConfig = {
    type: 'color-picker',
    templateOptions: {
      hideFieldUnderline: true,
    },
  };

  constructor() {
    super();
  }

  get templateOptions(): ISnColorPickerTemplateOptions {
    return this.field.templateOptions;
  }

  public onValueChange(value: string): void {
    if (this.to.change) {
      this.to.change(this.field, value);
    }
  }
}
